import { gql, useMutation } from '@apollo/client';

import { GET_HOLIDAY_LOCATIONS_BY_COMPANY } from './get-holiday-locations-by-company.hook';

export const DELETE_HOLIDAY_SUBGROUP = gql`
  mutation deleteHolidaySubGroupById($holidaySubGroupId: String!) {
    deleteHolidaySubGroupById(holidaySubGroupId: $holidaySubGroupId)
  }
`;

export const useDeleteHolidaySubGroup = () => {
  const [deleteHolidaySubGroup] = useMutation(DELETE_HOLIDAY_SUBGROUP, {
    refetchQueries: [GET_HOLIDAY_LOCATIONS_BY_COMPANY],
  });

  return deleteHolidaySubGroup;
};
